import { createSelector } from '@reduxjs/toolkit';
import { FOfferType } from '../../../../packages/JsonQuery';
import { selectOfferType, selectTotalArea } from 'shared/selectors/jsonQuery';

const DEFAULT_LABEL = 'Площадь';

const format = (value: number) => value.toLocaleString('ru-RU');

export const selectTotalAreaLabel = createSelector([selectTotalArea, selectOfferType], ({ gte, lte }, offerType) => {
  const min = typeof gte === 'number' ? gte : null;
  const max = typeof lte === 'number' ? lte : null;
  const unit = (offerType & FOfferType.CommercialLand) !== 0 ? 'сот.' : 'м²';

  if (min !== null && max !== null) {
    return `${format(min)} - ${format(max)} ${unit}`;
  }

  if (min !== null) {
    return `от ${format(min)} ${unit}`;
  }

  if (max !== null) {
    return `до ${format(max)} ${unit}`;
  }

  return DEFAULT_LABEL;
});
